var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"viewBox":"0 0 16 14"}},[_c('path',{attrs:{"d":"M6,0V2h8V12H6v2H16V0ZM4,4,0,7l4,3V8h8V6H4Z","fill":_vm.color}})])}
var staticRenderFns = []

export { render, staticRenderFns }